import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://pwapps.pl/proxy'
})

export default instance